import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/hotelServiceDictionaryInfo', request)
}

export {get}
